/**
 * Returns the name corresponding to the given ID from the provided array of objects.
 * If no matching ID is found, the original ID is returned.
 * @param objects - An array of objects containing an 'id' and 'name' property.
 * @returns A function that accepts an ID and returns the corresponding name, or the original ID if no match is found.
 */
export default function getNameById(objects: { id: string; name: string }[]) {
    return (id: string) => objects?.find((item) => item.id === id)?.name || id;
}
